var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconModuleHassadGifts(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-module-hassad-gifts",
    transform: "translate(-31.997 0.003)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5839",
    "data-name": "Rectangle 5839",
    width: 92,
    height: 92,
    transform: "translate(31.997 -0.003)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "shop",
    d: "M61.3,57.777l-5.558-42.49a1.386,1.386,0,0,0-1.434-1.255h-7.53V12.778a10.578,10.578,0,0,0-21.155,0v1.255h-7.53a1.521,1.521,0,0,0-1.434,1.255L11.1,57.957a1.317,1.317,0,0,0,.359,1.076,1.278,1.278,0,0,0,1.076.538h47.51a1.55,1.55,0,0,0,1.076-.538A3.5,3.5,0,0,0,61.3,57.777Zm-33.7-45a8.606,8.606,0,0,1,17.211,0v1.255H27.415V12.778ZM13.969,56.522l5.2-39.8h6.454v3.586a2.4,2.4,0,0,0-1.434,2.331,2.51,2.51,0,0,0,5.02,0,2.584,2.584,0,0,0-1.434-2.331V16.722h17.39v3.586a2.4,2.4,0,0,0-1.434,2.331,2.51,2.51,0,1,0,5.02,0,2.584,2.584,0,0,0-1.434-2.331V16.722h6.454l5.2,39.8Z",
    transform: "translate(40.613 14.228)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModuleHassadGifts);
export default __webpack_public_path__ + "static/media/icon-module-hassad-gifts.c7397c6f.svg";
export { ForwardRef as ReactComponent };